module.exports = "<h4>La pagina che stai cercando\n  <strong>non è stata trovata</strong>\n</h4>"